import { useState, useEffect, useRef } from 'react';

/**
 * Degraded-connectivity support (Phase 19), single owner as of App.js
 * refactor Step 2 — App.js previously duplicated this logic inline.
 *
 *  - isOnline: tracks the browser's online/offline events.
 *  - retryQueueRef: callers push zero-argument async functions here when a
 *    request fails while offline; the queue is drained (in order, errors
 *    swallowed) as soon as the browser comes back online.
 */
export function useConnectivity() {
    const [isOnline, setIsOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
    const retryQueueRef = useRef([]);

    useEffect(() => {
        function onOnline() {
            setIsOnline(true);
            const queue = retryQueueRef.current.slice();
            retryQueueRef.current = [];
            (async () => {
                for (const fn of queue) {
                    try { await fn(); } catch (_) { }
                }
            })();
        }
        function onOffline() { setIsOnline(false); }
        window.addEventListener('online', onOnline);
        window.addEventListener('offline', onOffline);
        return () => {
            window.removeEventListener('online', onOnline);
            window.removeEventListener('offline', onOffline);
        };
    }, []);

    return { isOnline, retryQueueRef };
}
